<template>
  <div class="site-page nav-content-inset">
    <div class="site-page__inner">
      <h1 class="site-page__title">关于 CoolPeople</h1>
      <div class="site-page__card site-page__card--muted">
        <p class="site-page__lead">
          CoolPeople.AI，连接有趣的人和分享经验的地方。你的认知性格品味生活数字「AI 克隆体」，记录你的精彩瞬间。
        </p>
        <div class="site-page__search">
          <el-input
            v-model="search"
            placeholder="搜索本站内容…"
            :maxlength="20"
            clearable
          >
            <template #prefix>
              <el-icon><Search /></el-icon>
            </template>
          </el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Search } from '@element-plus/icons-vue'

const router = useRouter()
const route = useRoute()

const search = computed({
  get() {
    return route.query.search ?? ''
  },
  set(search) {
    router.replace({ query: { search } })
  }
})
</script>

<style scoped>
.site-page__search {
  max-width: 400px;
  width: 100%;
}
</style>
